import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import type { EstimatedPickupTime } from '@/data/models/reservation.model';
import tripLegUtils from '@/services/triplegUtils';

import { useReservationFormMachines } from '../ReservationFormMachinesContext';
import { useFieldActorSnapshot } from '../hooks/useFieldActorSnapshot';
import type { TripLegEstimatedPickupContext } from '../machines/tripLegEstimatedPickup.machine';

function formatTravelTimeMinutes(minutes: number): string {
  const rounded = Math.ceil(minutes);
  return rounded === 1 ? '1 min' : `${rounded} mins`;
}

function formatEstimatedTravelDisplay(
  estimatedPickupTime: EstimatedPickupTime,
): { time: string; distance: string } {
  const travelMinutes =
    estimatedPickupTime.distance * estimatedPickupTime.travelTimeFactor;
  return {
    time: formatTravelTimeMinutes(travelMinutes),
    distance: tripLegUtils.formatDistance({
      distance: estimatedPickupTime.distance,
    }),
  };
}

const EstimatedTravelTimeMessage = ({ index }: { index: number }) => {
  const { t } = useTranslation('common');
  const { fieldRefs } = useReservationFormMachines();
  const snapshot = useFieldActorSnapshot(
    fieldRefs.tripLegEstimatedPickupRefs[index],
  );
  const { estimatedPickupTime } = (snapshot?.context ?? {
    estimatedPickupTime: null,
  }) as TripLegEstimatedPickupContext;

  if (!estimatedPickupTime) return null;

  const { time, distance } = formatEstimatedTravelDisplay(estimatedPickupTime);

  return (
    <Typography>
      {t('reservation.estimatedTravelTime', {
        time,
        distance,
      })}
    </Typography>
  );
};

export { EstimatedTravelTimeMessage };
